import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { Map, Iterable } from 'immutable';
import isEmpty from 'lodash/isEmpty';

import Grid       from '@mui/material/Grid';
import TextField  from '@mui/material/TextField';

import debounce from 'helpers/debounce';

function Number({
  name = null,
  value = null,
  onChange = null,
  minimum = 1,
  maximum = 999999,
  disabled = false,
  forced,
}) {
  const [state, setState] = useState(new Map());

  const input  = state.get('input', (value && value.get('value')) || '');

  function onTextChange(e) {
    if (e.target.value.length > maximum) return;

    let val = e.target.value.replace(/\D+/g, '');

    setState(state.set('input', val));

    // Note: Moved out of useEffect to avoid retriggering of "save() when toggling back via "prev" button
    if (isEmpty(val) || val.length > maximum || val.length < minimum) val = ''; // Sets response as invalid in index

    debounce(() => {
      onChange(name, new Map({ number: val }));
    }, 500, name);
  }

  useEffect(() => {
    if (forced) {
      onChange(name, new Map({ number: input || t('eos.landing_page.label.no_answer'), forced: true }));
    }
  }, [forced]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <TextField
          id="outlined-number"
          type="text"
          InputLabelProps={{ shrink: true }}
          disabled={disabled}
          sx={{
            width:
            '100%',
            '& input::-webkit-inner-spin-button, input::-webkit-outer-spin-button': {
              WebkitAppearance: 'none',
              margin:           0,
            },
            '& input[type=number]': {
              MozAppearance: 'textfield',
            },
          }}
          value={input}
          onChange={(e) => onTextChange(e)}
          helperText={t('eos.landing_page.text.min_max_char', { min: minimum, max: maximum })}
          error={!isEmpty(input) && (input.length < minimum || input.length > maximum)}
          data-testid="textfield-number"
        />
      </Grid>
    </Grid>
  );
}

// https://github.com/yannickcr/eslint-plugin-react/issues/2079#issuecomment-447358434
Number.propTypes = {
  name:     PropTypes.string,
  value:    PropTypes.objectOf(Iterable),
  onChange: PropTypes.func,
  minimum:  PropTypes.number,
  maximum:  PropTypes.number,
  disabled: PropTypes.bool,
  forced:   PropTypes.bool,
};

export default Number;
